import { useCallback } from "react";
import { cloneDeep } from "lodash";
import { useFormAPI } from "@/widgets/classic-form/form";
import { FormLevelFeatureType, useMetadataQuery } from "@/entities/form-metadata";

export const useToggleTimespanMatchMode = () => {
    const { setFieldValue, getFieldValue } = useFormAPI();
    const { data: formMetadata } = useMetadataQuery();
    const timespanFeature = formMetadata.features.find((f) => f.featureType === FormLevelFeatureType.Timespan);

    return useCallback(
        (newValue: boolean) => {
            if (!timespanFeature) return;

            const timespan = getFieldValue("timespan");
            if (!timespan.isVisible) return;

            const valueCopy = cloneDeep(timespan);
            valueCopy.matchMode = newValue ? "mustMatch" : "rankOnly";

            setFieldValue("timespan", valueCopy);
        },
        [getFieldValue, setFieldValue, timespanFeature],
    );
};
